// grid-state.service.ts
import { Injectable } from '@angular/core';
import { openDB, DBSchema } from 'idb';

interface WidgetGridState {
  id: string; // use widgetUniqKey as string
  config: Record<string, any>
}

interface GridDB extends DBSchema {
  widget_config: {
    key: string;
    value: WidgetGridState;
  };
}

@Injectable({ providedIn: 'root' })
export class UserStorageService {
  private dbPromise = openDB<GridDB>('userDB', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('widget_config')) {
        db.createObjectStore('widget_config', { keyPath: 'id' });
      }
    },
  });

  async saveGridStates(data: Partial<WidgetGridState>, baseConfig?: any): Promise<void> {
    const db = await this.dbPromise;
    const existing = await db.get('widget_config', data.id!);

    const merged = {
      id: data.id!,
      config: {
        ...(existing?.config || {}),
        ...(baseConfig || {}),
        ...(data.config || {})
      }
    };

    await db.put('widget_config', merged);
  }

  async getGridState(id: string): Promise<WidgetGridState | undefined> {
    const db = await this.dbPromise;
    return db.get('widget_config', id);
  }

  async clearAllStates(): Promise<void> {
    const db = await this.dbPromise;
    await db.clear('widget_config');
  }
}
